import { render } from "./TestDashboard.vue?vue&type=template&id=4269eafe"
import script from "./TestDashboard.vue?vue&type=script&lang=js"
export * from "./TestDashboard.vue?vue&type=script&lang=js"

import "./TestDashboard.vue?vue&type=style&index=0&id=4269eafe&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__